import React, {Component} from 'react';
import {Button, Modal,ProgressBar} from "react-bootstrap";
import JSZip from 'jszip'

class DownloadAllDesignsModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            savedDesigns: [],
            progress: 0
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));


    componentDidUpdate(prevProps) {
        if (this.props.show != prevProps.show && this.props.show === true) {
            const folder_id = this.props.currFolder
            let folder = this.props.folders.find(element => element['folder']['_id'] === folder_id)["folder"];
            if(folder && folder["type"] == "design"){
                const designsInFolder = this.getFolderPaths();
                const url = global.config.server_path+'saved_design/get';
                fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({ids : designsInFolder})})
                .then(res => res.json())
                .then(data => {
                    this.setState({savedDesigns : data.data})
                    return data.data;
                })
                .then(async (data) => {
                    await this.downloadDesigns(data,folder.name);
                })
                .catch(err => console.error(err))
            }else if(folder && folder["type"] == "photo"){
                this.downloadPhotos(this.getFolderPaths(),folder.name)
            }
        }
    }

    getFolderPaths = () => {
        const folder_id = this.props.currFolder
        let curr_folder = this.props.folders.find(element => element['folder']['_id'] === folder_id);
        if (curr_folder) {
            return curr_folder['folder']['resources'].map(x => x.path);
        }
        else {
            return [];
        }
    }

    downloadDesigns = async (savedDesigns,folder_name) => {
        var zip = new JSZip();
        for (let i = 0; i < savedDesigns.length; i++) {
            let design = new window.DM_Design();
            design.load(savedDesigns[i].design_file);
            design.base_width = design.get_width();
            design.handleWindowResize();
            design.draw();
            await design.wait_to_load();
            design.draw();

            var download_option = "png"
            var render_data = []
            for(var p=0;p<design.pages.length;p++){
                var html_data = design.pages[p].get_html(true);
                var rendering_parameters =  { pdf_quality: 'normal' };
                rendering_parameters.width = Math.floor(design.get_width() * design.pixelsPerCm);
                rendering_parameters.height = Math.floor(design.get_height() * design.pixelsPerCm);
                render_data.push({ type: download_option, html_data, rendering_parameters })
            }

            var data = await window.feline_fetch({ url: 'render/initiate_bulk', body: { render_data } })
		    await window.wait_for_export(data,download_option)

            for(var j = 0; j < data.length; j++) {
				zip.file(savedDesigns[i].name + "_" + Number(i+1) + "_" + Number(j+1) +'.' + download_option, window.urlToBinary(global.config.server_path + 'uploads/rendering_outputs/'+data[j]._id + '.' + download_option), {binary: true});
			}
            
            await this.set_state({progress: ((i+1)/savedDesigns.length)*100})
        }
        zip.generateAsync({type:"blob"})
        .then(function(content) {
            window.saveAs(content, folder_name + ".zip");
        });
    }

    downloadPhotos = async (photos,folder_name) => {
        var zip = new JSZip();
        for (let i = 0; i < photos.length; i++) {
            var prom = new Promise((resolve,reject) => {
                var img = new window.Image();
                img.crossOrigin = 'anonymous';
                img.src = global.config.server_path + photos[i];
                img.onload = function(){
                    var canvas = window.document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    canvas.getContext('2d').drawImage(img,0,0,img.width,img.height);
                    resolve(canvas.toDataURL());
                }
                img.onerror = function(){
                    reject("error");
                }
            })

            var datauri = await prom;

            zip.file(i + ".png", datauri.replace(/^data:image\/(png|jpg);base64,/, ""), {base64: true});
            await this.set_state({progress: ((i+1)/photos.length)*100})
        }
        zip.generateAsync({type:"blob"})
        .then(function(content) {
            window.saveAs(content, folder_name + ".zip");
        });
    }

    render() {
        return (
            <Modal show={this.props.show}
                   onHide={this.props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Downloading all resources</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.progress!=100?(<ProgressBar now={this.state.progress}></ProgressBar>):(<div style={{textAlign:'center',color:'green',fontWeight:'bold'}}>Your download is ready!</div>)}
                </Modal.Body>
            </Modal>
        );
    }
}

export default DownloadAllDesignsModal;